import configuration from '../config.js';

export type ApiClient = ReturnType<typeof createApiClient>;

export function createApiClient(token: string) {
  const base = configuration['backend_host'];
  const authHeader = { Authorization: `Bearer ${token}` };
  return {
    get: (path: string) => fetch(`${base}${path}`, { headers: authHeader }).then((r) => r.json()),
    post: (path: string, body: unknown) =>
      fetch(`${base}${path}`, {
        method: 'POST',
        headers: { ...authHeader, 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      }).then((r) => r.json()),
    put: (path: string, body: unknown) =>
      fetch(`${base}${path}`, {
        method: 'PUT',
        headers: { ...authHeader, 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      }).then((r) => r.json()),
    delete: (path: string) =>
      fetch(`${base}${path}`, { method: 'DELETE', headers: authHeader }).then((r) => r.json()),
  };
}
